import React from "react";
import { DPUserRosterFile } from "Shared/types/UserRoster";
import { TableRow, TableCell } from "@material-ui/core";
import pretty from "Shared/pretty";
import Formatting from "Modules/DataExchange/Formatting";
import UserRosterTableViewButton from "./UserRosterTableViewButton/UserRosterTableViewButton";
import { useDownloadBatchOnBoard } from "./useDownloadBatchOnBoard";
import { DPPermissionGate } from "Components/DP";

type Props = {
  onboardFile: DPUserRosterFile;
};
const UserRosterTableRow = ({ onboardFile }: Props) => {
  const { id, creator, originalFilename, status, createdAt } = onboardFile;
  const fullName = Formatting.dataExchangeFullName(
    creator.firstName || "",
    creator.lastName || ""
  );
  const { downloadBatchOnboardById } = useDownloadBatchOnBoard();

  return (
    <TableRow>
      <TableCell>
        {pretty.date(createdAt, { withTime: true })}
      </TableCell>
      <TableCell>{fullName}</TableCell>
      <TableCell>{originalFilename}</TableCell>
      <TableCell>{pretty.titleizeWord(status)}</TableCell>
      <DPPermissionGate permissionKeys={["canViewBatchOnboard"]}>
        <TableCell>
          {status.toLocaleLowerCase() === "processed" && (
            <UserRosterTableViewButton
              onViewClick={downloadBatchOnboardById(id)}
            />
          )}
        </TableCell>
      </DPPermissionGate>
    </TableRow>
  );
};

export default UserRosterTableRow;
